var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.898 62.039",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".thumb_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1.039)",
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "thumb_icon_svg__a",
    d: "M58.909 31.499h1.794a4.992 4.992 0 015.195 4.75 4.992 4.992 0 01-5.195 4.752h-1.794"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumb_icon_svg__a",
    d: "M58.9 41.002a4.984 4.984 0 015.195 4.743 4.543 4.543 0 01-1.518 3.359 5.455 5.455 0 01-3.676 1.392h-3.509"
  }), /*#__PURE__*/React.createElement("path", {
    className: "thumb_icon_svg__a",
    d: "M55.393 50.497h-.072a4.992 4.992 0 015.195 4.752 4.992 4.992 0 01-5.195 4.752H13.933M13.933 30.983c0-5.841 15.252-13.042 14.122-22.48L26.906.31s5.751-.746 7.725.074c5.069 2.073 6.362 8.807 6.362 13.747a26.6 26.6 0 01-1.293 7.868h19.208a4.992 4.992 0 015.195 4.752 4.992 4.992 0 01-5.195 4.748M0 30.508h13.933V60H0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.31,
    cy: 1.196,
    rx: 1.31,
    ry: 1.196,
    transform: "translate(5.571 53.364)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thumb_icon.546c4878335be504e49e8ee14fcfc613.svg";